<!--
 * @Author: your name
 * @Date: 2020-03-24 15:00:14
 * @LastEditTime: 2020-03-31 16:01:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlonmarinesite\src\pages\pdf.vue
 -->
<template>
  <div class="row body-width divcss5">
    <div class="body-width" style="margin-top: 80px">
      <div class="div-row pr-padding-top news-Medium-24">
        “领航”大模型海上自动驾驶
      </div>
      <div class="div-row">
					<p class="indentation">
						“领航”大模型船长是基于DeepSeek人工智能大模型算法，嵌入特别设计的海洋信息感知模块，并经过海量船舶驾驶数据微调训练而成。目前推出的“领航”大模型船长0.1版已经具备一定的港到港自动驾驶和开阔水域简单场景的避碰能力。
					</p>
				</div>
      <div class="div-row">
        <div class="div-top">
          <div class="div-margin" @click="tzclick(1)">
            <img src="../assets/images/case1.jpg" />
          </div>
          <div class="div-top3"> 简单场景：“领航”大模型船长操纵船舶从蓬莱港开往旅顺港。</div>
        </div>

        <div class="div-top1 box2">
          <div class="div-margin" @click="tzclick(2)">
            <img src="../assets/images/case2.jpg" />
          </div>
          <div class="div-top3">会遇场景：“领航”大模型船长操纵船舶从蓬莱港开往旅顺港，路遇其他船舶进行避让。</div>
        </div>
        
        <div class="div-top2">
          <div class="div-margin" @click="tzclick(3)">
            <img src="../assets/images/case3.jpg" />
          </div>
          <div class="div-top3"> 绕行岛屿场景：“领航”大模型船长操纵船舶从海南洋浦海域绕过涠洲岛抵达广西北海海域。</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
export default {
  name: "Pdf",
  mounted() {},
  components: {},
  data() {
    return {
      lmmadUrl: "",
    };
  },
  methods: {
    tzclick(val) {
      if (val == 1) {
        this.$router.push("/jdcj");
      } else if (val == 2) {
        this.$router.push("/hccj");
      }else if (val == 3) {
        this.$router.push("/rdcj");
      }
    },
  },
};
</script>
<style scoped>
.divcss5 {
  margin: 0 auto;
}

.body-width {
  width: 1300px;
}

.row {
  display: flex;
  flex-wrap: wrap;
}

.div-row {
  clear: both;
}

.pr-padding-top {
  padding-top: 35px;
  padding-bottom: 30px;
}

.news-Medium-24 {
  font-family: Medium;
  font-size: 24px;
  color: #333;
}

.indentation {
  text-indent: 2em;
  text-align: left;
  color: #666;
  font-size: 16px;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

.div-top {
  float: left;
  padding-left: 40px;
}
.div-margin {
  width: 435px;
  height: 328px;
  cursor: pointer;
}

img {
  width: 100%;
  height: 100%;
  vertical-align: middle;
}

.div-top1 {
  float: right;
  padding-right: 40px;
  margin-bottom: 280px;
}

.div-top2 {
  float: left;
  padding-left: 40px;
  margin-top: -300px;
}

.div-top3 {
  margin-bottom: 40px;
  margin-top: 10px;
  color: #b6b6b6;
}
</style>



// WEBPACK FOOTER //
// src/pages/lmmad.vue